module.exports = __webpack_public_path__ + "img/momo.68d86baf.jpeg";